export default class FixitColumn {
    constructor(args) {
        this.id = args?.id || -1
        this.column = args?.column || ""
        this.columnDescription = args?.columnDescription || ""
        this.active = args?.active || false
        this.isMappingRequired = args?.isMappingRequired || false
    }
}
